import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ModuleStructure } from 'src/app/models/module-structure';
import * as Handlebars from 'handlebars';
import { Action } from '../record-model';
import { ModuleInformation } from 'src/app/models/module-information';
import { RecordPageComponent } from '../record-page/record-page.component';

@Component({
  selector: 'app-records-list-cards',
  templateUrl: './records-list-cards.component.html',
  styleUrls: ['./records-list-cards.component.less'],
})
export class RecordsListCardsComponent implements OnInit {
  @Input() moduleStructure: ModuleStructure;
  @Input() listOfRecords: any;
  @Input() isLoading = true;
  @Input() isEditable = false;
  @Input() selectedRecords: string[] = [];
  @Input() selectedRecordsFromCheckBox: string[] = [];
  @Input() pageSize: number;
  @Input() isKanban = false;
  @Input() keyName = 'KEY';
  @Input() moduleActions: Action[];
  @Input() moduleInformation: ModuleInformation;
  @Input() showCheckBoxInTableMode = false;
  @Input() inModuleList = false;
  @Input() fromDraft = false;
  @Output() selectRecord = new EventEmitter<any>();
  @Output() reloadRecords = new EventEmitter();
  @Input() customActions: { label: string; key: string }[];
  @Output() customActionClicked = new EventEmitter<{
    key: string;
    value: any;
  }>();
  @Output() selectRecordFromCheckBox = new EventEmitter<any>();
  isEditAuthorized = false;
  pageSizeArray: number[] = [];

  constructor(
    private drawerService: NzDrawerService
  ) { }

  ngOnInit(): void {
    let index = 0;
    while (index < 8) {
      this.pageSizeArray.push(index);
      index++;
    }
    this.isEditAuthorized = this.moduleInformation.AuthorisedForEdit;
  }

  rowSelectedFromCheckBox(data, event) {
    if (this.inModuleList) {
      this.selectRecordFromCheckBox.emit({ data, event });
    } else {
      if (event) {
        console.log(event);

        this.selectRecord.emit(data);
      } else {
        this.selectRecord.emit(undefined);
      }
    }
  }

  getRecordHtml(record) {
    const template = Handlebars.compile(
      this.moduleStructure.module.AdditionalInformationParsed.ListTemplate
    );
    const html = template(record);
    return html;
  }
  editRecord(recordId) {
    console.log('moduleInformation', this.moduleInformation);
    console.log('moduleInformation', this.moduleStructure);

    RecordPageComponent.openRecordPage(this.drawerService,
      {
        actionType: 'edit',
        drawerTitle: 'Edit',
        inDrawer: true,
        moduleId: this.moduleStructure.module.Id,
        parentComponent: this,
        recordId,
        recordModel: undefined,
      });
  }
  linkedObjectSubmitted() {
    this.reloadRecords.emit();
  }

  selectCard(data){
    if (
      !(
        data['U_ITM_ACTIVE'] == null ||
        data['U_ITM_ACTIVE'] === undefined ||
        data['U_ITM_ACTIVE'] === 'true'
      )
    ) {
      return;
    }
    this.selectRecord.emit(data)
  }
}
